<script>
/**
 * /app/canais/detalhe — só existe pra compatibilidade com links antigos.
 *
 * Toda a gestão (info, edição, posts em tempo real) agora vive na index.
 * Esta rota redireciona pra lá automaticamente. Se o usuário aterrissa aqui
 * com `?id=N`, o canal é pré-selecionado quando a index carregar (sessão
 * usa localStorage temporário).
 */
export default {
  name: 'CanalDetalheRedirect',
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      try { sessionStorage.setItem('canal_pre_selecionado', String(id)); } catch (_e) { /* opcional */ }
    }
    // replace pra não poluir o histórico
    this.$router.replace({ path: '/app/canais' });
  },
  render() {
    return null;
  },
};
</script>
